<script>
  import Icon from './icon.svelte';

  export let icons = []; // Lista de iconos (ej: ["siPython", "java", "siNodedotjs"])
</script>

<div class="icon-stack">
  {#each icons as icon, i}
    <span class="icon" style="z-index: {10 + icons.length - i}; left: {i * 1}em;">
      <Icon icon={icon} colored="true" />
    </span>
  {/each}
</div>

<style>
  .icon-stack {
    display: flex;
    align-items: center; /* Centra verticalmente */
    justify-content: center; /* Centra horizontalmente */
    position: relative;
    height: 5em; /* Ajusta según tamaño de iconos */
  }

  .icon {
    /*position: absolute;*/
    /*top: 50%;*/
    /*transform: translateY(-50%); !* Corrige el centrado vertical *!*/
  }

  .icon-stack .icon:nth-child(1) { left: 0; }
  .icon-stack .icon:nth-child(2) { left: 14px; }
  .icon-stack .icon:nth-child(3) { left: 28px; }
</style>